export default __webpack_public_path__ + "static/mobile-app-f912fe2a93b4251decf6dfc03121ba78.png";